module.exports = __webpack_public_path__ + "static/media/Service2.b1eb9339.svg";